// extracted by mini-css-extract-plugin
export default {"container":"styles_container__lupBf","title":"styles_title__b+SzA"};